import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import Lodinging from "../components_root/loading.jsx";
import Lodingingimg from "../components_root/loadingimg.jsx";
import { Helmet } from "react-helmet";

import { Toast } from '../components_root/ToastContext.jsx';
import { VscDashboard } from "react-icons/vsc";
import { MdAdd, MdAddAPhoto, MdAnalytics, MdArrowBackIos, MdChangeCircle, MdClose, MdDashboard, MdDeleteForever, MdFileOpen, MdFileUpload, MdHome, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdSettings, MdSettingsAccessibility, MdTraffic, MdUpload } from "react-icons/md";
import { Uploader_companies_files } from "../components_root/uploader_companies_files.js";
import banner_default from '../assets/banner_default.jpg';
import logo_default from '../assets/logo_default.jpg';
import ShareButton from "../components_root/ShareButton.jsx";
import FollowButton from "../follow_root/follow_button.js";
import { Get_company_information } from "./get_company_information.js";
import { Delete_service_information } from "./delete_service_information.js";
import { Mode_change_service } from "./mode_chnage_service.js";
import { PiBooks } from "react-icons/pi";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Manage_data() {
    const location = useLocation();
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [company, setCompany] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading_banner, setIsLoading_banner] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("home");
    const [companyData, setCompanyData] = useState([]);
    const [uid, setUid] = useState("");
    const [old_file_uid, setOld_file_uid] = useState("");
    const [old_banner_file_uid, setOld_banner_file_uid] = useState("");
    const [logoUrl, setLogoUrl] = useState("");
    const [BannerUrl, setBannerUrl] = useState("");
    const [servicetablename, setservicetablename] = useState("");
    const [serviceid, setserviceid] = useState("");
    const [companyuid, setCompanyuid] = useState("");
    const [guid, setGuid] = useState("");
    const [servicesdata, setservicesdata] = useState([]);

    useEffect(() => {
        const sessionToken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        if (sessionToken && guid) {
            setGuid(guid);
        } else {
            setGuid(null);
        }

    }, []);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setservicetablename(params.get("service"));
        setserviceid(params.get("id"));
    }, []);

    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid || !servicetablename || !serviceid) return;

        const loadCompanyServices = async () => {
            try {
                const q = query(
                    collection(db, "companies", select_company_uid, servicetablename),
                    //  where("serviceid", "==", serviceid)
                );

                const servicesSnap = await getDocs(q);

                const allServices = [];
                servicesSnap.forEach(doc => {
                    allServices.push({
                        id: doc.id,
                        ...doc.data(),
                    });
                });

                setservicesdata(allServices);
            } catch (error) {
                console.error("Error fetching services:", error);
            }
        };

        loadCompanyServices();
    }, [servicetablename, serviceid]);
    const getExpireDate = (timestamp, days) => {
        if (!timestamp?.toDate || !days) return null;
        const d = timestamp.toDate();
        d.setDate(d.getDate() + days);
        return d.toLocaleDateString();
    };
    const getDueDays = (timestamp, totalDays) => {
        if (!timestamp?.toDate || !totalDays) return 0;

        const startDate = timestamp.toDate();
        const expireDate = new Date(startDate);
        expireDate.setDate(expireDate.getDate() + totalDays);

        const today = new Date();

        const diffTime = expireDate - today;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };

    const handleDelete = async () => {
        let datatablenames = [];

        if (servicetablename === "accountingfinancedb") {
            datatablenames = [
                "cash_books_accounting",
                "favorites",
                "ledger_accounts",
                "ledger_accounts_manager",
                "ledger_books",
                "print_setting",
                "print_settings_account_apply",
                "voucher_print",
                "vouchers",
                "files",
                "voucher_file_manager",
                "voucher_print_stock",
            ];
        }

        let totalDeleted = 0;

        try {
            for (const table of datatablenames) {
                const res = await Delete_service_information(servicetablename, table);

                if (!res.success) {
                    Toastshow(res.error);
                    return;
                }

                totalDeleted += res.deleted || 0;
            }

            Toastshow(`Deleted ${totalDeleted} records successfully`);
        } catch (err) {
            Toastshow(err.message || "Delete failed");
        }
    };

    const set_mode_change_service = async () => {
        const res = await Mode_change_service("companies", servicetablename, serviceid);

        if (!res.success) {
            alert(res.error);
            return;
        }
        navigate(-1);
        Toastshow("Mode changed successfully");
    };


    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
                            onClick={() => navigate("/company?page=company")}
                            className="button-ui0 text-h2 bold p-2 cursor fcap">
                            <MdArrowBackIos className="icon" />{servicesdata[0]?.slug || "Service"}
                        </div></td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/company?page=company")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <div className="container_size_info">

                {servicesdata.map(row => (
                    <div key={row.id} className="ui-items m-1  rounded p-11"  >

                        <table >
                            <tbody>
                                <tr className='b-bottom'>
                                    <td width={70}><img src={row.logo_url} className="service_photo m-1-r rounded" /></td>
                                    <table>
                                        <td>
                                            <td className='text-h1 text-l bold fcap'>
                                                {row.slug}
                                            </td>
                                        </td>
                                        <tr>

                                            <td className="text-h2 "  >
                                                {row.date_time?.toDate ? (
                                                    <>
                                                        {row.date_time.toDate().toLocaleDateString()}{" "}
                                                        {row.date_time.toDate().toLocaleTimeString()}
                                                    </>
                                                ) : (
                                                    <div className="text-h3">Not Billing</div>
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={row.mode_test ? "red bold text-h2" : "text-h2"}>
                                                Mode: {row.mode_test ? "Test" : "Production"}
                                            </td>
                                        </tr>

                                    </table>

                                </tr>

                                <tr>
                                    <td className="text-h3 text-off fcap">Status</td>

                                    <td
                                        className={`text-h2 bold ${row.status ? "green" : "red"
                                            }`}
                                    >
                                        {row.status ? "Activate" : "Deactivate"}
                                    </td>

                                    <td></td>
                                </tr>
                                <tr>
                                    <td className='text-h3 text-off fcap'>Billing date</td>
                                    <td className="text-h2 bold"  >
                                        {row.last_bill_date_time?.toDate ? (
                                            <>
                                                {row.last_bill_date_time.toDate().toLocaleDateString()}{" "}
                                                {row.last_bill_date_time.toDate().toLocaleTimeString()}
                                            </>
                                        ) : (
                                            <div className="text-h3">Not Billing</div>
                                        )}
                                    </td>
                                    <td width={70} className="text-h3 text-r">{row.days} Days</td>
                                </tr>
                                <tr>
                                    <td className="text-h3 text-off fcap">Expire</td>

                                    <td className="text-h2 bold red">
                                        {getExpireDate(row.last_bill_date_time, row.days) || "Not Billing"}
                                    </td>

                                    <td width={70} className="text-h3 text-r red bold">
                                        {getDueDays(row.last_bill_date_time, row.days)} Days
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <div className='text-h3 text-off fcap m-top'>{row.description}</div>


                        {row.mode_test === true ? (

                            <>
                                <div className="b-top m-top ">
                                    <strong>Note:</strong> If the service mode is <b className="bold red">Test</b>, it is <span className="bold red">not safe</span> for real work. All service data will be deleted when you switch to <b className="bold green">Production</b>.<br />
                                    This deletion occurs only once. After the mode is changed to <b>Production</b>, no records will be deleted.
                                </div>

                                <table>
                                    <tr>
                                        <td>
                                            <div className="button-ui cursor m-2 p-22 rounded red-back" onClick={() => set_mode_change_service()}><MdChangeCircle className="icon" />Mode: Test</div>
                                        </td>
                                        <td>
                                            <div className="button-ui cursor m-2 p-22 rounded" onClick={() => handleDelete("cash_books_accounting")}><MdDeleteForever className="icon" /> Service Delete Forever</div>
                                        </td>
                                    </tr>
                                </table>
                            </>
                        ) : (<div className="b-top m-top ">
                            <strong>Note:</strong> The service is in <b className="bold green">Production</b> mode and is safe to use. No data will be deleted.<br /> You can start your work confidently and use the service professionally.
                        </div>)}


                    </div>
                ))}

            </div>
        </div>
    );
}
